/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClinicGroupDetailModel } from '../../models/clinic-group-detail-model';

export interface PractitionerPractitionerIdClinicGroupsGet$Params {
  practitionerId: string;
}

export function practitionerPractitionerIdClinicGroupsGet(http: HttpClient, rootUrl: string, params: PractitionerPractitionerIdClinicGroupsGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<Array<ClinicGroupDetailModel>>> {
  const rb = new RequestBuilder(rootUrl, practitionerPractitionerIdClinicGroupsGet.PATH, 'get');
  if (params) {
    rb.path('practitionerId', params.practitionerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PracticeStrictHttpResponse<Array<ClinicGroupDetailModel>>;
    })
  );
}

practitionerPractitionerIdClinicGroupsGet.PATH = '/Practitioner/{practitionerId}/ClinicGroups';
